<mat-expansion-panel class="capa-details__panel" *ngIf="capa">
  <mat-expansion-panel-header>
    <mat-panel-title>
      CAPA/EC Detais
    </mat-panel-title>    
  </mat-expansion-panel-header>

  <div class="capa-details__panel__header">
    <button mat-raised-button class="edit-button" (click)="editCapa()" *ngIf="canUpdate">Edit</button>
  </div>

  <div class="capa-details__panel__values">
    <div class="capa-details__panel__values--id iaud-value-container">
      <label for="capa-id">CAPA/EC ID:</label>
      <p id="capa-id">{{ capa?.capaId }}</p>
    </div>

    <div class="capa-details__panel__values--title iaud-value-container">
      <label for="capa-title">CAPA/EC Title:</label>
      <p id="capa-title">{{ capa?.capaTitle }}</p>
    </div>

    <div class="capa-details__panel__values--type iaud-value-container">
      <label for="capa-type">CAPA/EC Type:</label>
      <p id="capa-type">{{ capaType }}</p>
    </div>

    <div class="capa-details__panel__values--pics iaud-value-container">
      <label for="capa-owner-group">CAPA/EC PICs:</label>
      <p id="pics" *ngFor="let pic of capa?.capaPics">
        {{ pic.fullName }}
      </p>
    </div>

    <div class="capa-details__panel__values--description iaud-value-container description">
      <label for="capa-description">CAPA/EC Description:</label>
      <p id="capa-description">{{ capa?.description }}</p>
    </div>

    <div class="capa-details__panel__values--due-date iaud-value-container">
      <label for="capa-due-date">Evidence Submission Due Date</label>
      <p id="capa-due-date">{{ capa?.evidenceDueDate | date:dateFormat }}</p>
    </div>

    <div class="capa-details__panel__values--status iaud-value-container">
      <label for="capa-status">CAPA/EC Status:</label>
      <p id="capa-status">{{ capa?.status }}</p>
    </div>
    <div class="capa-details__panel__values--act-status iaud-value-container">
      <label for="capa-act-status">CAPA/EC Activity Status:</label>
      <p id="capa-act-status">{{ capa?.status }}</p>
    </div>
    <div class="capa-details__panel__values--submission iaud-value-container">
      <label for="capa-rights">Evidence Submission Rights:</label>
      <p id="capa-rights" *ngIf="capa?.allMustSubmit">All CAPA/EC PICs required to submit</p>
      <p id="capa-rights" *ngIf="!capa?.allMustSubmit">Only one of CAPA/EC PICs required to submit</p>
    </div>
  </div>
</mat-expansion-panel>